<template>
  <div id="app" :class="{ stopScroll: mobileMenuActive }">
    <vue-progress-bar></vue-progress-bar>
    <template v-if="this.$route.meta.isPublic === false">
      <template v-if="userLoaded === false || setupLoaded === false">
        <TheLoadScreen></TheLoadScreen>
      </template>
      <template v-else>
        <TheSidebar></TheSidebar>
        <div class="main-wrapper">
          <div class="main-vertical">
            <main class="main">
              <TheTopbar></TheTopbar>
              <div class="content">
                <TheBreadcrumb></TheBreadcrumb>
                <div class="container-fluid">
                  <router-view :key="$route.fullPath"></router-view>
                </div>
              </div>
            </main>
          </div>
        </div>
        <TheMessages />
        <TheLightbox />
      </template>
    </template>
    <template v-else>
      <!-- Full page nie wymagające zalogowania -->
      <router-view :key="$route.fullPath"></router-view>
    </template>
  </div>
</template>

<script>
import TheTopbar from "./components/TheTopbar.vue";
import TheSidebar from "./components/TheSidebar.vue";
import TheBreadcrumb from "./components/TheBreadcrumb.vue";
import TheLoadScreen from "./components/TheLoadScreen.vue";
import TheMessages from "./components/TheMessages.vue";
import TheLightbox from "./components/TheLightbox.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  components: {
    TheLoadScreen,
    TheTopbar,
    TheSidebar,
    TheBreadcrumb,
    TheMessages,
    TheLightbox,
  },
  mounted() {
    let routeMeta = this.$route.meta;
    //-- First load application
    if (this.loggedIn === true) {
      // let loadQueue = [, ];

      this.load().then(() => {
        this.getCompanies().then(() => {
          this.loadSetup(this.getRole).then(() => {
            if (
              routeMeta.permission &&
              routeMeta.isPublic === false &&
              this.$route.name !== "error404" &&
              this.hasAccess(routeMeta.permission) === false
            ) {
              this.$router.push("/error");
              return false;
            }
          });
        });
        //When user don't have right to access then redirect to error page
      });
    }
  },
  computed: {
    ...mapGetters("user", ["userLoaded", "loggedIn", "hasAccess", "getRole"]),
    ...mapGetters("app", ["setupLoaded"]),
    ...mapGetters("app", ["mobileMenuActive"]),
  },
  data() {
    return {
      isReady: false,
    };
  },
  methods: {
    ...mapActions("user", ["load"]),
    ...mapActions("app", ["loadSetup"]),
    ...mapActions("company", ["getCompanies"]),
  },
};
</script>
